var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9582 3.1665H15.0415C10.5632 3.1665 8.32399 3.1665 6.93275 4.55775C5.5415 5.94899 5.5415 8.18816 5.5415 12.6665V25.3332C5.5415 29.8115 5.5415 32.0506 6.93275 33.4419C8.32399 34.8332 10.5632 34.8332 15.0415 34.8332H22.9582C27.4365 34.8332 29.6756 34.8332 31.0669 33.4419C32.4582 32.0506 32.4582 29.8115 32.4582 25.3332V12.6665C32.4582 8.18816 32.4582 5.94899 31.0669 4.55775C29.6756 3.1665 27.4365 3.1665 22.9582 3.1665Z",
    fill: "#970268"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8335 7.125H22.1668",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9995 30.0835H19.0153",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClm);
export default __webpack_public_path__ + "static/media/clm.4fd2ce2c131f8991b56b777e0c9b52fd.svg";
export { ForwardRef as ReactComponent };